module.exports = __webpack_public_path__ + "47826e6f81e169f6b34c6219351cfc12.svg";